import { render, staticRenderFns } from "./g-comment.vue?vue&type=template&id=ca540dfc&scoped=true"
import script from "./g-comment.vue?vue&type=script&lang=js"
export * from "./g-comment.vue?vue&type=script&lang=js"
import style0 from "./g-comment.vue?vue&type=style&index=0&id=ca540dfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca540dfc",
  null
  
)

export default component.exports